var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mc-trackvision-live-streaming__video-status-badge",class:{
    online: _vm.isOnline,
    offline: !_vm.isOnline,
  },attrs:{"title":_vm.isOnline ? _vm.$t('trackVideo.videoOnline') : _vm.$t('trackVideo.videoOffline')}},[_c('i',{staticClass:"mc-fa icon-fill_video"}),_vm._v(" "+_vm._s(_vm.isOnline ? 'ONLINE' : 'OFFLINE')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }